import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { RouteNames } from '~/app/providers/router/config/routeConfig';
import { getRawToken } from '~/helpers/utility';

export const ProtectedRoutes = () => {
  return getRawToken() ? <Outlet /> : <Navigate to={RouteNames.LOGIN_LINK} />;
};
